<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-dialog class="progress" v-model="progress.dialog" persistent max-width="0px">
        <v-progress-circular indeterminate color="red"></v-progress-circular>
      </v-dialog>
      <v-app id="inspire" class="app">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>   
           <!-- App Footer -->
          <v-footer height="auto" class="white pa-3 app--footer">
            <span class="caption">BanBanTaxi Admin &copy; {{ new Date().getFullYear() }}</span>
            <v-spacer></v-spacer>
            <span class="caption mr-1"> Make With Love </span> <v-icon color="pink" small>favorite</v-icon>
          </v-footer>
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
        <!-- theme setting -->
        <v-btn small fab dark falt fixed top="top" right="right" class="setting-fab" color="red" @click="openThemeSettings">
          <v-icon>settings</v-icon>
        </v-btn>
        <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
          >
          <theme-settings></theme-settings>
        </v-navigation-drawer>        
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon> 
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>    
  </div>
</template>
<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import menu from '@/api/menu';
import ThemeSettings from '@/components/ThemeSettings';
import AppEvents from  './event';
import State  from '@/api/state';
import PaymentState  from '@/api/paymentState';
import ReportState  from '@/api/reportState';
import RunningState  from '@/api/runningState';
import CouponType  from '@/api/couponType';
import Gender  from '@/api/gender';
import CallCancelReason  from '@/api/callCancelReason';
import PushMessageAction  from '@/api/pushMessageAction';
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: '',
    },
    progress: {
      dialog: false
    },
    state: State,
    paymentState: PaymentState,
    reportState: ReportState,
    runningState: RunningState,
    couponType: CouponType,
    gender: Gender,
    callCancelReason: CallCancelReason,
    pushMessageAction: PushMessageAction,
    prevPagination: null,
    prevPageName: null,
    prevSearchFormModel: null,
    commonError: null
  }),

  computed: {

  },

  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  methods: {
    openThemeSettings () {
      this.$vuetify.goTo(0);
      this.rightDrawer = (!this.rightDrawer);
    },
    changeStateText (stateCode) {
      if (stateCode != null) {
        for (let i = 0; i < this.state.length; i++) {
          if (this.state[i].state === stateCode) {
            return this.state[i].text;
          }
        }
      } else {
        return '';
      }
    },
    changePaymentStateText (stateCode) {
      if (stateCode != null) {
        for (let i = 0; i < this.paymentState.length; i++) {
          if (this.paymentState[i].state === stateCode) {
            return this.paymentState[i].text;
          }
        }
      } else {
        return '';
      }
    },
    changeReportStateText (stateCode) {
      if (stateCode != null) {
        for (let i = 0; i < this.reportState.length; i++) {
          if (this.reportState[i].state === stateCode) {
            return this.reportState[i].text;
          }
        }
      } else {
        return '';
      }
    },
    changeDateText (date) {
      if (date != null) {
        let tmpDate = new Date(date);
        return tmpDate.toLocaleDateString().substr(0, 12).replace(' ', '').replace(' ', '') + ' '
              + tmpDate.toLocaleTimeString();
      } else {
        return '-';
      }
    },
    changeCouponTypeText (couponType) {
      if (couponType != null) {
        for (let i = 0; i < this.couponType.length; i++) {
          if (this.couponType[i].state === couponType) {
            return this.couponType[i].text;
          }
        }
      } else {
        return '-';
      }
    },
    changeRunningStateText (stateCode) {
      if (stateCode != null) {
        for (let i = 0; i < this.runningState.length; i++) {
          if (this.runningState[i].state === stateCode) {
            return this.runningState[i].text;
          }
        }
      } else {
        return '';
      }
    },
    changeGenderText (gender) {
      if(!gender) return '';

      for (let i = 0; i < this.gender.length; i++) {
        if (this.gender[i].state === gender) {
          return this.gender[i].text;
        }
      }
    },
    changeCallCancelReasonText (reason) {
      if(!reason) return '';

      for (let i = 0; i < this.callCancelReason.length; i++) {
        if (this.callCancelReason[i].state === reason) {
          return this.callCancelReason[i].text;
        }
      }
    },
    changePushMessageActionText (action) {
      if(!action) return '';

      for (let i = 0; i < this.pushMessageAction.length; i++) {
        if (this.pushMessageAction[i].state === action) {
          return this.pushMessageAction[i].text;
        }
      }
    },
    addPrevData (pageName, pagination, searchFormModel) {
      if(pageName) this.prevPageName = pageName;
      if(pagination) this.prevPagination = pagination;
      if(searchFormModel) this.prevSearchFormModel = searchFormModel;
    },
    clearPrevData () {
      this.prevPagination = null;
      this.prevSearchFormModel = null;
      this.prevPageName = null;
    }
  },

};
</script>


<style lang="stylus" scoped>
  .setting-fab 
    top:50%!important; 
    right:0;
    border-radius:0  
  .page-wrapper
    min-height:calc(100vh - 64px - 50px - 81px );  

</style>



// WEBPACK FOOTER //
// src/App.vue